{
  "index": {
    "in_progress": "Vos données s’afficheront ici."
  },
  "search": "Rechercher",
  "main": {
    "title": "Bienvenue sur le tableau de bord Admin",
    "subtitle": "Admin"
  },
  "tickets": {
    "title": "Gestion des tickets",
    "subtitle": "Tableau de bord - Changement d'étape",
    "drag_and_drop": {
      "not_allowed": "L'action n'est pas autorisée"
    }
  },
  "sidebar": {
    "category": {
      "application": "Application"
    },
    "links": {
      "home": "Accueil",
      "dashboard": "Dashboard",
      "tickets": "Gestion des tickets",
      "users": "Gestion des utilisateurs",
      "internal_signers": "Gestion des signataires internes",
      "contacts": "Gestion des contacts",
      "crm_users": "Gestion des référents CRM",
      "workflows": "Gestion des Flux",
      "packages": "Gestion des Packs d'avantages",
      "operations": "Gestion des types d'opérations",
      "identity": "Fiche d'identité",
      "contract_templates": "Gestion des modèles de contrat",
      "conventions": "Gestion des conventions",
      "email_reminders": "Relances automatiques",
      "attachments_templates": "Gestion des modèles de pièces jointes",
      "products": "Produit(s)",
      "therapeutic_areas": "Aire(s) thérapeutique(s)",
      "sectors": "Secteur(s)",
      "units": "Service(s)",
      "regions": "Region(s)",
      "specialties": "Gestion des Spécialité(s)",
      "settings": {
        "label": "Paramètres",
        "signatures": "Signature électronique",
        "watchdogs": "Alertes",
        "upsell": "Upsell",
        "notifications": "Notifications",
        "permissions": "Permissions"
      },
      "signatures_settings": "Signature électronique",
      "simplified_declarations": "Déclarations simplifiées",
      "declarations": "Déclarations simplifiées",
      "allocation": {
        "label": "Rattachements",
        "therapeutic_areas": "Aire(s) thérapeutique(s)",
        "unit": "Service(s)",
        "sector": "Secteur(s)",
        "region": "Region(s)",
        "product": "Produit(s)",
        "network": "Réseau(x)",
        "uga": "UGA(s)",
        "zone": "Zone(s)",
        "identity": "Entité(s)"
      },
      "management": {
        "label": "Gestions",
        "tickets": "Tickets",
        "users": "Utilisateurs",
        "internal_signers": "Signataires internes",
        "contacts": "Contacts",
        "workflows": "Flux",
        "packages": "Packs d'avantages",
        "operations": "Types d'opérations",
        "contract_templates": "Modèles de contrat",
        "conventions": "Conventions",
        "attachments_templates": "Modèles de pièces jointes",
        "specialties": "Spécialités",
        "declarations": "Déclarations simplifiées",
        "crm_users": "Référents CRM"
      }
    }
  },
  "table": {
    "header": {
      "attachment_template": {
        "name": "Nom du fichier",
        "type": "Type de fichier",
        "comment": "Commentaire"
      },
      "crm_user": {
        "firstname": "Prénom",
        "lastname": "Nom",
        "email": "Email",
        "responsibilities": "Role",
        "post_title": "Fonction",
        "staff_id": "Matricule"
      },
      "user": {
        "first_name": "Prénom",
        "last_name": "Nom",
        "email": "Email",
        "phone_number": "Numéro de téléphone",
        "enabled": "État"
      },
      "ticket": {
        "name": "Nom",
        "status": "Statut",
        "step": "Etape"
      },
      "internal_signer": {
        "firstname": "Prénom",
        "lastname": "Nom",
        "executive_role": "Fonction",
        "email": "Email",
        "phone_number": "Numéro de téléphone",
        "civility": "Civilité",
        "staff_id": "Matricule"
      },
      "contact": {
        "name": "Nom",
        "details": "Détails"
      },
      "contract_template": {
        "name": "Nom",
        "signature_request_type": "Type de procédure de signature"
      },
      "package": {
        "name": "Nom",
        "advantages": "Avantages",
        "email": "Email",
        "phone_number": "Phone number"
      },
      "workflow": {
        "name": "Nom",
        "steps": "Étapes"
      },
      "notifications": {
        "name": "Nom",
        "notification_type": "Type de notification",
        "event_type": "Type de manifestation",
        "operation_type": "Type d'opération",
        "criteria": "Critères",
        "state": "État"
      },
      "common": {
        "actions": "Actions"
      }
    }
  },
  "common": {
    "cancel": "Annuler"
  },
  "package": {
    "tabs": {
      "planned": "Packages prévus",
      "actual": "Packages réels"
    },
    "title": {
      "create": "Créer un pack",
      "edit": "Modifier un pack"
    },
    "name": "Nom",
    "create": "Créer Pack",
    "update": "Mise à jour du pack",
    "abort_update": "Annuler la mise à jour",
    "distribution_pack": "Pack à répartition"
  },
  "operation": {
    "search_placeholder": "Rechercher un type d'opération par nom",
    "selected_entity": "type(s) opération(s)",
    "list_title": {
      "all": "Types d'opérations",
      "enabled": "Types d'opérations actifs",
      "disabled": "Types d'opérations inactifs"
    },
    "title": {
      "create": "Créer un type d'opération",
      "edit": "Modifier une opération"
    },
    "tab": {
      "general_informations": "Informations générales",
      "link": "Liens"
    },
    "name": "Nom",
    "create": "Créer un type d'opération",
    "update": "Mise à jour de l'opération",
    "modal": {
      "title": "Mise à jour du type d'opération",
      "text": "Souhaitez-vous impacter les tickets existants ? Cette opération est irreversible.",
      "clone": "Modifier sans impacter",
      "edit": "Valider"
    },
    "input": {
      "name": "Nom",
      "eventTypes": "Type de manifestation",
      "donation_type": "Type de don",
      "operation_type_transparency": "Type d'opération Transparence Santé",
      "operation_type_eps": "Type d’opération EPS",
      "operation_type_idahe": "Type de manifestation IDAHE",
      "donation_types": {
        "DONATION_AND_GENEROSITY_FOR_RESEARCH_ACTIVITIES": "Dons et libéralités pour activités de recherche",
        "DONATIONS_FOR_HEALTH_RELATED_ACTIVITIES": "Dons pour d’autres activités en lien avec la santé",
        "DONATION_FOR_PUBLIC_UTILITY": "Dons pour utilité publique"
      },
      "idahe_convention": "Convention IDAHE",
      "idahe_typology": "Typologie IDAHE",
      "idahe_conventions": {
        "RESEARCH": "Conventions dans le cadre d’activités de recherche, de valorisation de la recherche, d’évaluation scientifique, de conseil, de prestation de service ou de promotion commerciale",
        "MANIFESTATION": "Conventions dans le cadre de manifestations à caractère exclusivement professionnel ou scientifique, de manifestations à promotion des produits ou prestations mentionnés à l’article L. 1453-8 du code de la santé publique",
        "FINANCIAL": "Conventions visant le financement ou la participation au financement d’actions de formation professionnelle ou de développement professionnel continu"
      },
      "idahe_typologies": {
        "OTHER": "Autres",
        "AWARD_CONTRACT": "Contrat de remise de prix",
        "CONGRESS_REGISTRATION_CONTRACT": "Contrat d’inscription aux congrès",
        "CONSULTING_NON_SCIENTIFIC_CONTRACT": "Contrat de conseil / d'expertise autre que scientifique",
        "EVENT_SPEAKER_CONTRACT": "Contrat d'intervenant à une manifestation",
        "EXPERT_SCIENTIFIC_CONTRACT": "Contrat d'expert scientifique",
        "GRANT_AWARD_CONTRACT": "Contrat de remise d'une bourse de recherche",
        "MARKET_STUDY": "Enquête, étude, étude de marché (hors recherche)",
        "PARTNERSHIP": "Partenariat",
        "PATRONAGE": "Mécénat",
        "PURCHASE_RENTAL_ADVERTISING_SPACE_CONTRACT": "Contrat d'achat ou de location d'espaces publicitaires",
        "PURCHASE_RENTAL_SCIENTIFIC_EVENT_SPACE_CONTRACT": "Contrat d'achat ou de location d'espaces dans le cadre de manifestations scientifiques",
        "RESEARCH_CONTRACT": "Contrat de recherche scientifique",
        "SCIENTIFIC_EVALUATION_CONTRACT": "Contrat d'évaluation scientifique",
        "SPONSORSHIP": "Parrainage",
        "TRAINING": "Formation"
      },
      "package": {
        "planned": "Package(s) prévu(s)",
        "actual": "Package(s) réel(s)"
      },
      "mandatory": {
        "packages": "Pack(s) imposé(s)",
        "contract_templates": "Modèle(s) de contrat(s) imposé(s)",
        "attachments": "Modèle(s) de pièce(s) jointe(s) imposée(s)"
      },
      "contract_template": "Modèle(s) de contrat(s)",
      "attachments": "Modèle(s) de pièce(s) jointe(s)",
      "is_publication_allowed": "Opération à publier"
    },
    "is_enabled": {
      "title": "État",
      "enabled": "Actif",
      "disabled": "Inactif"
    },
    "enable": "Activer",
    "disable": "Désactiver"
  },
  "convention": {
    "selected_entity": "convention(s)",
    "list_title": {
      "all": "Conventions",
      "enabled": "Conventions actives",
      "disabled": "Conventions inactives"
    },
    "title": {
      "create": "Créer une convention",
      "edit": "Modifier une convention"
    },
    "create": "Créer une convention",
    "name": "Nom",
    "type": "Type",
    "advantages": "Avantages",
    "tabs": {
      "enabled": "Actif",
      "disabled": "Inactif"
    },
    "enable": "Activer",
    "disable": "Désactiver",
    "button": {
      "create": "Créer",
      "edit": "Éditer"
    },
    "inputs": {
      "type": {
        "NONE": "Aucune",
        "RECURRING_PROFESSIONAL_MEETING_ONE_AND_HALF_TO_EIGHT_HOURS_2026": "Convention 2026/01 - Réunions professionnelles répétitives ou en soirée - durée 1h30 à 8h",
        "WEEKEND_SEMINAR_2026": "Convention 2026/02 - Manifestations professionnelles et scientifiques répétitives, séminaire de fin de semaine",
        "ON_SITE_TRAINING_HALF_TO_TWO_DAYS_2026": "Convention 2026/03 - Sessions de formations pratiques sur site - Durée 1/2 journée à 2 jours",
        "INDUSTRIAL_SITE_MEETING_ONE_TO_TWO_DAYS_2026": "Convention 2026/04 - Réunions à visée professionnelle organisée sur site industriel - Durée 1 journée à 2 jours",
        "STAFF_MEETING_2026": "Convention 2026/05 - Staff",
        "ON_SITE_TRAINING_HALF_TO_TWO_DAYS_2024": "Convention 2024/03 - Sessions de formations pratiques sur site - Durée 1/2 journée à 2 jours",
        "INDUSTRIAL_SITE_MEETING_ONE_TO_TWO_DAYS_2024": "Convention 2024/04 - Réunions à visée professionnelle organisée sur site industriel - Durée 1 journée à 2 jours",
        "RECURRING_PROFESSIONAL_MEETING_ONE_AND_HALF_TO_EIGHT_HOURS_2024": "Convention 2024/01 - Réunions professionnelles répétitives ou en soirée - durée 1h30 à 8h",
        "WEEKEND_SEMINAR_2024": "Convention 2024/02 - Manifestations professionnelles et scientifiques répétitives, séminaire de fin de semaine",
        "STAFF_MEETING_2024": "Convention 2024/05 - Staff",
        "STAFF_MEETING_2020": "Convention 2020 - Staff",
        "RECURRING_PROFESSIONAL_MEETING1_2020": "Convention 2020 - Réunions Professionnelles Répétitives 1",
        "RECURRING_PROFESSIONAL_MEETING2_2020": "Convention 2020 - Réunions Professionnelles Répétitives 2",
        "ON_SITE_TRAINING_HALF_TO_ONE_DAY1_2020": "Convention 2020 - Formation sur site 1",
        "ON_SITE_TRAINING_HALF_TO_ONE_DAY2_2020": "Convention 2020 - Formation sur site 2",
        "INDUSTRIAL_SITE_MEETING_ONE_DAY1_2020": "Convention 2020 - Réunions sur site industriel 1",
        "INDUSTRIAL_SITE_MEETING_ONE_DAY2_2020": "Convention 2020 - Réunions sur site industriel 2",
        "WEEKEND_SEMINAR_2020": "Convention 2020 - Séminaires de fin de semaine"
      },
      "is_manual_pack_allowed": "Création manuelle de packs autorisée"
    }
  },
  "ticket": {
    "cta": {
      "create": "Créer un ticket"
    }
  },
  "allocation": {
    "subtype": {
      "name": "Nom",
      "enabled": "Actif",
      "disabled": "Inactif",
      "all": "Tout",
      "state": "État",
      "action": "Actions",
      "input": {
        "name": "Nom",
        "filter": "Filtrer un état"
      },
      "product": {
        "create_title": "Créer un produit",
        "edit_title": "Modifier un produit",
        "enabled": "Produit actif",
        "disabled": "Produit Inactif",
        "create": "Créer",
        "update": "Éditer"
      },
      "therapeutic_area": {
        "create_title": "Créer une aire thérapeutique",
        "edit_title": "Modifier une aire thérapeutique",
        "enabled": "Aire thérapeutique active",
        "disabled": "Aire thérapeutique Inactive",
        "create": "Créer",
        "update": "Éditer"
      },
      "sector": {
        "create_title": "Créer un secteur",
        "edit_title": "Modifier un secteur",
        "enabled": "Secteur actif",
        "disabled": "Secteur Inactif",
        "create": "Créer",
        "update": "Éditer"
      },
      "region": {
        "create_title": "Créer une région",
        "edit_title": "Modifier une région",
        "enabled": "Region active",
        "disabled": "Region Inactive",
        "create": "Créer",
        "update": "Éditer"
      },
      "unit": {
        "create_title": "Créer un service",
        "edit_title": "Modifier un service",
        "enabled": "Service actif",
        "disabled": "Service Inactif",
        "create": "Créer",
        "update": "Éditer"
      },
      "network": {
        "create_title": "Créer un réseau",
        "edit_title": "Modifier un réseau",
        "enabled": "Réseau actif",
        "disabled": "Réseau Inactif",
        "create": "Créer",
        "update": "Éditer"
      },
      "uga": {
        "create_title": "Créer une UGA",
        "edit_title": "Modifier une UGA",
        "enabled": "UGA actif",
        "disabled": "UGA Inactif",
        "create": "Créer",
        "update": "Éditer"
      },
      "zone": {
        "create_title": "Créer une zone",
        "edit_title": "Modifier une zone",
        "enabled": "Zone actif",
        "disabled": "Zone Inactif",
        "create": "Créer",
        "update": "Éditer"
      },
      "identity": {
        "create_title": "Créer une entité",
        "edit_title": "Modifier une entité",
        "enabled": "Entité active",
        "disabled": "Entité inactive",
        "create": "Créer",
        "update": "Éditer"
      }
    }
  },
  "internal_signer": {
    "title": {
      "create": "Créer un signataire interne",
      "edit": "Modifier un signataire interne"
    },
    "inputs": {
      "firstname": "Prénom",
      "lastname": "Nom",
      "executive_role": "Fonction",
      "phone": "Téléphone",
      "email": "Email",
      "civility": "Civilité",
      "staff_id": "Matricule"
    },
    "popup_modal_delete": {
      "title": "Suppression du signataire interne",
      "warning": "Cette action est irreversible. Êtes-vous sûr de vouloir supprimer ces données ?"
    },
    "cta": {
      "create": "Créer",
      "edit": "Éditer",
      "cancel": "Annuler"
    }
  },
  "contact": {
    "title": {
      "create": "Créer un contact",
      "edit": "Modifier un contact"
    },
    "name": "Nom",
    "create": "Créer Contact",
    "update": "Mise à jour du contact",
    "abort_update": "Annuler la mise à jour",
    "response_success": "Succès"
  },
  "user": {
    "tab": {
      "general_informations": "Informations générales",
      "allocations": "Rattachements"
    },
    "legends": {
      "personal_information": "Identification",
      "validators": "Validateurs",
      "roles": "Rôles"
    },
    "inputs": {
      "firstName": "Prénom",
      "lastName": "Nom",
      "email": "Email",
      "phone": "Téléphone",
      "staff_id": "Matricule",
      "user_enabled": "Utilisateur activé",
      "user_disabled": "Utilisateur désactivé",
      "first_validators": "Validateur 1",
      "second_validators": "Validateur 2",
      "products": "Produit(s)",
      "sectors": "Secteur(s)",
      "therapeuticAreas": "Aire(s) thérapeutique(s)",
      "units": "Service(s)",
      "regions": "Région(s)",
      "networks": "Réseau(x)",
      "ugas": "UGA(s)",
      "zones": "Zone(s)",
      "identities": "Entité(s)",
      "search": "Rechercher",
      "add_all": "Tout ajouter",
      "remove_all": "Tout retirer"
    },
    "create": {
      "title": "Créer un utilisateur"
    },
    "edit": {
      "title": "Modifier un utilisateur",
      "front_roles": "Rôles utilisateur",
      "admin_roles": "Rôles administrateur",
      "roles": {
        "assigned": "Rôles assignés actuellement",
        "modification": "Modifications des rôles",
        "label": "Roles",
        "placeholder": "Sélectionnez un rôle à ajouter"
      }
    },
    "enabled": {
      "true": "Activé",
      "false": "Désactivé"
    },
    "cta": {
      "create": "Créer un utilisateur",
      "submit": "Modifier",
      "save_configuration": "Enregistrer la configuration"
    },
    "filter": {
      "placeholder": "Filtre"
    },
    "response_success": "Succès",
    "response_graphql_error": "Une erreur inattendue s'est produite. Veuillez réessayer plus tard",
    "response_common_error": {
      "firstName": "Vous devez renseigner le champ 'Prénom'",
      "lastName": "Vous devez renseigner le champ 'Nom'",
      "email": "Vous devez renseigner le champ 'Email'"
    },
    "selected": "Sélectionné(e)(s)"
  },
  "workflow": {
    "list_title": "Flux disponibles",
    "title": {
      "create": "Créer un Flux",
      "edit": "Éditer un Flux"
    },
    "create": "Créer un Flux",
    "steps": "Étapes",
    "steps_available": "Étapes disponibles",
    "step_number": "Etape .{number}",
    "step_order": "Ordre des étapes",
    "event_type": "Type de manifestation",
    "description": "Description",
    "actions": "Actions",
    "name": "Nom",
    "button_create": "Créer",
    "button_update": "Éditer",
    "cancel": "Annuler",
    "response_success": "Succès",
    "message_error": {
      "no_name": "Vous devez fournir un nom pour le workflow",
      "no_steps": "Vous devez fournir au moins une étape pour le workflow",
      "query_error": "Une erreur s'est produite lors de la création du workflow"
    }
  },
  "identity": {
    "title": {
      "create": "Créer une entité",
      "edit": "Modifier une entité"
    },
    "modal": {
      "title": "Modification de l’entité",
      "description": "Les modifications apportées vont impacter les profils utilisateurs et les manifestations existantes.",
      "confirm": "Souhaitez vous effectuer cette action ?"
    },
    "inputs": {
      "name": "Dénomination sociale",
      "company_form": "Forme société",
      "capital": "Capital",
      "place_of_registration": "Lieu d'immatriculation",
      "rcs": "RCS",
      "gdpr_contact": "Contact RGPD",
      "mail_gdpr_contact": "Mail contact RGPD",
      "address": "Adresse",
      "postal_code": "Code Postal",
      "city": "Ville",
      "department": "Département",
      "country": "Pays",
      "legal_notice": "Mentions légales",
      "eps_login": "Login EPS",
      "eps_password": "Mot de passe EPS",
      "idahe_login": "Login IDAHE",
      "idahe_password": "Mot de passe IDAHE",
      "representative_name": "Représentant",
      "representative_title": "Titre du représentant",
      "no_urssaf_rate": "Taux non URSSAF"
    },
    "logo": {
      "drag_and_drop_statement": "Glissez-déposez votre logo ici",
      "or_statement": "Ou si vous préférez",
      "cta_label": "Sélectionnez un fichier depuis votre appareil"
    },
    "enabled": "Activé",
    "disabled": "Désactivé",
    "validate": "Valider",
    "cancel": "Annuler",
    "response_success": "Succès",
    "main_identity": "Entité principale",
    "details": "Informations du laboratoire",
    "avatar": "Avatar"
  },
  "contract_templates": {
    "create_page_title": "Créer un modèle de contrat",
    "edit_page_title": "Modifier un modèle de contrat",
    "create": "Créer un modèle de contrat",
    "update": "Modifier un modèle de contrat",
    "back_from_create": "Revenir à la gestion des modèles de contrat",
    "documents": {
      "title": "Versions du modèle de contrat",
      "headers": {
        "version": "Version",
        "name": "Nom du fichier",
        "date": "Date",
        "hour": "Heure",
        "created_by": "Uploadé par",
        "filesize": "Taille du fichier",
        "status": "Statut"
      },
      "status": {
        "ACTIVE": "Actif",
        "ARCHIVED": "Archivé"
      }
    }
  },
  "settings": {
    "label": "Paramètres",
    "upsell": {
      "title": "Paramétrage des options",
      "UPSELL_ANS": {
        "title": "ANS"
      },
      "UPSELL_DQC": {
        "title": "Activer le menu Analytique"
      },
      "UPSELL_NOTIFICATIONS_CENTER": {
        "title": "Paramétrage des notifications"
      }
    },
    "watchdogs": {
      "HOSPITALITY": {
        "title": "Hospitalités étudiant",
        "description": "Un étudiant n'est pas autorisé à recevoir des hospitalités : repas, diner, déjeuner, nuit, collation, transport et inscription."
      },
      "UNANNOUNCED": {
        "title": "Impromptus",
        "description": "Un professionnel de santé ne peut être invité que deux fois maximum par année en cours pour un type d’opération Impromptu.",
        "inputs": {
          "UNANNOUNCED_OPERATIONS": {
            "label": "Veuillez sélectionner le(s) type(s) d’opération(s) pour lequel l’alerte sera visible :"
          }
        }
      },
      "TICKET_DEADLINE": {
        "title": "Dossier hors délais",
        "description": "Informer du nombre de jour restant avant le début de la manifestation.",
        "inputs": {
          "TICKET_DEADLINE_DAYS": {
            "label": "Veuillez saisir le nombre de jour calendaire avant le début de la manifestation à partir duquel l’alerte sera visible pour les régimes d’autorisation. Nombre minimum accepté : 60, nombre maximum accepté : 200."
          },
          "TICKET_DEADLINE_WORK_DAYS": {
            "label": "Veuillez saisir le nombre de jour ouvrable avant le début de la manifestation à partir duquel l’alerte sera visible pour les régimes de déclaration. Nombre minimum accepté : 8, nombre maximum accepté : 200."
          }
        }
      },
      "ATTENDEE_ADDED_POST_SUBMISSION": {
        "title": "Ajout participant post soumission",
        "description": "Un participant a été ajouté au dossier après l'étape soumission et gestion."
      },
      "SIMPLE_EVENTS_BY_DECLARATION": {
        "title": "Nombre d'événements simplifiés liés à la déclaration simplifiée",
        "description": "Indication du nombre d'événements liés et du nombre d'événements prévus à la déclaration simplifiée"
      },
      "ATTENDEE_SPECIALTY_DIFFERENT_FROM_DECLARATION": {
        "title": "Spécialité différente de celles annoncées dans la déclaration simplifiée",
        "description": "Un PS invité à un événement simplifié a une spécialité différente de celles présentes dans la déclaration simplifiée."
      },
      "SIGNED_CONTRACT": {
        "title": "Contrat signé pour autorisation",
        "description": "Il manque les contrats signés pour des participants à partir de l'étape de soumission et gestion."
      }
    },
    "permissions": {
      "title": "Permissions",
      "description": "Récapitulatif des permissions associées au rôle ",
      "custom_permissions": "Initiateur restreint",
      "initiator": "Initiateur",
      "list": {
        "EDIT_INFORMATION": "Accès à  Informations générales et pièces jointes",
        "EDIT_ATTENDEES": "Accès à Invités prévus : Listes des invités, Rechercher, Saisie manuelle, importer la liste",
        "EDIT_PLANNED_ADVANTAGES": "Accès à Avantages prévus : Création de packs, parcourir les packs existants, attribution de packs, import des dépenses prévues",
        "EDIT_SIGNING_SHEET": "Accès à Emargement : affectation statut de présence, facturation et feuille d'émargement",
        "EDIT_CONTRACT_MANAGEMENT": "Accès à Génération des contrats ",
        "EDIT_SIGNING": "Accès à Signature : envoi des contrats en signature ",
        "EDIT_ACTUAL_ADVANTAGES": "Accès à Participants/Dépenses réelles : Création de packs, parcourir les packs existants, attribution de packs, répartition détaillée, import des dépenses réelles, frais annexes et justificatifs "
      },
      "save": "Enregistrer les modifications"
    }
  },
  "signatures_settings": {
    "tabs": {
      "procedure": "Procédure",
      "automatic_reminders": "Relances automatiques",
      "security_code": "Code de sécurité",
      "workspace": "Espace de travail"
    },
    "automatic_reminders": {
      "update_success": "Le paramétrage de relance a été validé",
      "interval_in_days": {
        "title": "Fréquences de relances",
        "label": "Veuillez sélectionner la fréquence des relances automatiques à appliquer sur l’ensemble de vos tickets",
        "EVERY_DAY": "Tous les jours",
        "EVERY_TWO_DAY": "Tous les 2 jours",
        "EVERY_WEEK": "Toutes les semaines",
        "EVERY_TWO_WEEK": "Toutes les deux semaines"
      },
      "max_occurrences": {
        "title": "Nombre de relances",
        "label": "Veuillez saisir le nombre de relances automatiques à appliquer sur l’ensemble de vos tickets"
      },
      "warning": {
        "title": "Activation des relances",
        "text": "Toute relance activée n'aura pas d'effet rétroactif."
      }
    },
    "security_code": {
      "update_success": "Le paramétrage d'authentification a été validé",
      "text": "Définissez le mode d'authentification pour vos procédures de signature",
      "mail": "Code de sécurité par email",
      "sms": "Code de sécurité par SMS",
      "none": "Aucun code de sécurité",
      "warning": {
        "title": "Code de sécurité",
        "text": "Tout changement du mode d'authentification n'aura pas d'effet rétroactif."
      }
    },
    "workspace": {
      "update_success": "Le paramétrage de l'espace de travail a été validé",
      "workspace_id": {
        "title": "Veuillez entrer l'ID de l'espace de travail",
        "placeholder": "ID de l'espace de travail"
      },
      "custom_experience_id": {
        "title": "Veuillez entrer l'ID de l'expérience personnalisée",
        "placeholder": "ID de l'expérience personnalisée"
      }
    }
  },
  "declarations": {
    "title": "Déclarations simplifiées",
    "create_declaration": "Créer une déclaration simplifiée",
    "create_declaration_title": "Déclarations simplifiées",
    "edit_declaration_title": "Modifier une déclaration simplifiée",
    "breadcrumbs": {
      "informations": "Informations générales",
      "themes": "Thèmes",
      "deposit": "Dépôt",
      "attachments": "Fichiers joints",
      "simple-events": "Événements simplifiés"
    },
    "update_success": "La déclaration a bien été mise à jour.",
    "update_advantage": "Mise à jour de l'avantage",
    "archived": "Archivée",
    "canceled": "Annulée",
    "modal": {
      "trash": {
        "title": "Confirmation de suppression",
        "description": "Êtes-vous sûr de vouloir supprimer cette Déclaration simplifiée :",
        "button": "Confirmer la suppression"
      }
    },
    "deposit": {
      "informations": "Informations du dépôt",
      "inputs": {
        "reference": {
          "label": "Référence administrative de la soumission",
          "placeholder": "Renseignez la référence de la soumission"
        },
        "url": {
          "label": "URL",
          "placeholder": "Renseignez l'URL de la soumission"
        },
        "submission_date": "Date d'envoi de la soumission",
        "recommendation_date": "Date de réception de la recommandation",
        "comment": {
          "label": "Commentaire",
          "placeholder": "Renseignez le commentaire de la soumission"
        },
        "status": {
          "label": "Statut de la soumission",
          "TO_SUBMIT": "Soumission à envoyer",
          "SUBMITTED": "Soumission envoyée",
          "CANCELED": "Soumission annulée"
        }
      },
      "cta": {
        "create": "Enregistrer",
        "edit": "Modifier",
        "cancel": "Annuler"
      }
    },
    "status": {
      "CREATING": "En création",
      "TO_EDIT": "À modifier"
    },
    "workflow_step": {
      "FIRST_VALIDATION": "Première validation",
      "SECOND_VALIDATION": "Deuxième validation",
      "SENT": "Envoyée",
      "ACCEPTED": "Acceptée",
      "REFUSED": "Refusée",
      "ACTIVATED": "Référencée"
    },
    "filter": {
      "all": "Tout"
    },
    "search": {
      "placeholder": "Rechercher par nom / code"
    },
    "upsert": {
      "inputs": {
        "legends": {
          "identification": "Identification",
          "attendees": "Invités",
          "validations": "Validations",
          "details": "Détails",
          "coordinates": "Adresse",
          "connectors": "Connecteurs"
        },
        "declaration_count": "Nombre d'évènements",
        "attendee_quantity": "Nombre moyen d'invité (par évènement)",
        "name": "Nom de la déclaration simplifiée",
        "number": "Nombre évènements",
        "date_range": "Date de début et de fin de la période couverte",
        "city": "Ville",
        "country": "Pays",
        "in_convention": "Avantages convention",
        "in_declaration": "Avantages déclaration simplifiée",
        "advantage": {
          "label": "Avantage {status}",
          "disabled": "désactivé",
          "enabled": "actif"
        },
        "convention_id": "Type de convention",
        "workflow": "Type de workflow",
        "initiator": "Initiateur",
        "validator_1": "Validateur 1",
        "validator_2": "Validateur 2",
        "reference": "Référence administrative",
        "external_code": "Référence CRM",
        "specialties": {
          "label": "Spécialité(s) IDAHE",
          "ALLERGOLOGY": "Allergologie",
          "ANATOMICAL_PATHOLOGY": "Anatomopathologie",
          "ANGIOLOGY": "Angiologie",
          "MEDICAL_BIOLOGY": "Biologie médicale",
          "CARDIOLOGY": "Cardiologie",
          "MAXILOFACIAL_SURG": "Chir maxillo-faciale stomato",
          "CARDIOVASCULAR_SURG": "Chir thoracique et cardiovasc",
          "VISCERAL_SURG": "Chir viscérale et digestive",
          "SURGERY": "Chirurgie",
          "FACE_SURG": "Chirurgie de la face et du cou",
          "INFANT_SURG": "Chirurgie infantile",
          "ORTHOPEDIC_SURG": "Chirurgie orthopédique",
          "PLASTIC_SURG": "Chirurgie plast. rec. esth.",
          "UROLOLOGIC_SURG": "Chirurgie urologique",
          "VASCULAR_SURG": "Chirurgie vasculaire",
          "DERMATOLOGY": "Dermatologie",
          "PROFESSIONAL_DVPT": "DPC et divers",
          "ENDOCRINOLOGY": "Endocrinologie",
          "GASTROENTEROLOGY": "Gastroentérologie",
          "GENETICS": "Génétique",
          "GERIATRICS": "Gériatrie",
          "MEDICAL_GYNECOLOGY": "Gynécologie médicale",
          "OBSTETRIC_GYNECOLOGY": "Gynécologie obstétrique",
          "HEMATOLOGY": "Hématologie",
          "INFECTIOLOGY": "Infectiologie",
          "READAPT_MEDICINE": "Méd phys et de réadaptation",
          "EMERGENCY_MEDICINE": "Médecine d'urgence",
          "SPORT_MEDICINE": "Médecine du sport",
          "WORK_MEDICINE": "Médecine du travail",
          "GENERAL_MEDICINE": "Médecine générale",
          "INTERN_MEDICINE": "Médecine interne",
          "NUCLEAR_MEDICINE": "Médecine nucléaire",
          "THERMAL_MEDICINE": "Médecine thermale",
          "MULTIDISCIPLINARY": "Multi-disciplinaire",
          "NEPHROLOGY": "Néphrologie",
          "NEUROSURGERY": "Neurochirurgie",
          "NEUROLOGY": "Neurologie",
          "ONCOLOGY": "Oncologie",
          "OPHTALMOLOGY": "Ophtalmologie",
          "ORL": "ORL",
          "PEDIATRICS": "Pédiatrie",
          "PHARMACOLOGY": "Pharmacologie",
          "PNEUMOLOGY": "Pneumologie",
          "PSYCHIATRY": "Psychiatrie",
          "MEDICAL_IMAGERY": "Radiodiag et imagerie médicale",
          "RADIOLOGY": "Radiologie opt. radio-thérap.",
          "ANESTHESIA": "Réa médicale - Anesthésie",
          "MEDICAL_RESEARCH": "Recherche médicale",
          "RHEUMATOLOGY": "Rhumatologie",
          "PUBLIC_HEALTH": "Santé publique et méd sociale",
          "STOMATOLOGY": "Stomatologie",
          "LOCAL_TRAINING_ORG": "Structure de FMC locale",
          "TRANSPLANT": "Transplantation"
        },
        "manager_crm": "Gestionnaire CRM"
      },
      "table": {
        "name": "Nom",
        "convention_id": "Type convention",
        "theme": "Thème",
        "start_at": "Date de début",
        "reference": "Référence",
        "created_at": "Date de création",
        "created_by": "Créateur",
        "status": "Statut",
        "nb_tickets": "Nombre de tickets/nombre prévu"
      },
      "buttons": {
        "submit": {
          "validate": "Enregistrer et valider",
          "send_to_validation": "Enregistrer et envoyer en validation"
        },
        "send_back_to_initiator": "Renvoyer à l'initiateur pour modification",
        "reference": "Référencer",
        "accept": "Accepter",
        "reject": "Refuser"
      }
    },
    "themes": {
      "inputs": {
        "name": "Intitulé thème",
        "duration": "Durée"
      },
      "placeholder": {
        "duration": "Renseigner au format heure HH:MM"
      },
      "name": "Intitulé du thème",
      "duration_per_hour": "Durée (heure)"
    },
    "attachments": {
      "drag_and_drop_statement": "Veuillez sélectionner un fichier ou le drag and drop ici",
      "inputs": {
        "type": "Type de fichier",
        "comment": "Commentaire",
        "upload": "Téléverser votre document"
      }
    },
    "advantages": {
      "total_error": "Les avantages ne peuvent dépasser le montant de la convention"
    },
    "simple-events": {
      "title": "Liste des évènements liés",
      "search_placeholder": "Rechercher par nom d'évènement",
      "table": {
        "code": "Code",
        "workflow_step": "Étape de workflow",
        "name": "Nom",
        "start_at": "Date de début",
        "end_at": "Date de fin",
        "present_doctors_count": "Nombre de médecins présents",
        "doctor_list_status": "Liste des participants"
      },
      "doctor_list_status": {
        "PENDING": "En attente de dépôt",
        "SENT": "Déposé",
        "CANCELED": "Annulé"
      },
      "floatBar": {
        "assign_to_events": "Assigner aux évènements liés"
      },
      "doctor_list_export": "Liste des médecins"
    }
  },
  "attachment_template": {
    "create": {
      "title": "Créer un modèle de pièce jointe"
    },
    "cta": {
      "create": "Créer un modèle de pièce jointe",
      "add": "Ajouter",
      "cancel": "Annuler"
    }
  },
  "specialties": {
    "name": "Nom",
    "technical_key": "Clé technique",
    "action": "Actions",
    "create": "Créer une spécialité",
    "edit": "Éditer une spécialité",
    "alert": {
      "edit": "La modification de cette spécialité impactera tous vos invités et contacts concernés par cette spécialité"
    },
    "button": {
      "create": "Créer",
      "update": "Éditer"
    },
    "input": {
      "name": "Nom",
      "technical_key": "Clé technique"
    }
  },
  "crm_user": {
    "popup_modal_delete": {
      "title": "Supprimer un référent CRM",
      "warning": "Cette action est irréversible. Êtes-vous sûr de vouloir supprimer ce référent CRM  ?"
    },
    "title": {
      "table_title": "Référent CRM",
      "create": "Créer un référent CRM",
      "edit": "Éditer un référent CRM"
    },
    "search": {
      "placeholder": "Rechercher un référent CRM"
    },
    "inputs": {
      "lastname": "Nom",
      "firstname": "Prénom",
      "email": "Email",
      "responsibilities": "Rôles",
      "post_title": "Fonction",
      "staff_id": "Matricule"
    },
    "responsibility": {
      "APPROVER": "Approbateur CRM",
      "MANAGER": "Gestionnaire CRM"
    }
  },
  "notifications": {
    "filters": {
      "type": {
        "all": "Tous",
        "enabled": "Actif",
        "disabled": "Inactif",
        "placeholder": "Type de notification"
      }
    },
    "input": {
      "name": {
        "label": "Nom",
        "placeholder": "Nom de la notification"
      },
      "type": "Type de notification",
      "operation": "Type d'opération",
      "event_types": {
        "label": "Type de manifestation",
        "CONTRACT": "Contrat",
        "EVENT": "Évènement déclaré",
        "DONATION": "Don",
        "SIMPLE_EVENT": "Évènement simplifié",
        "UNDECLARED_EVENT": "Évènement non déclaré"
      },
      "target_state": {
        "label": "État d'arrivée",
        "CREATING": "En création",
        "FIRST_VALIDATION": "Première validation",
        "SECOND_VALIDATION": "Deuxième validation",
        "TO_EDIT": "À modifier",
        "CONTRACT_MANAGEMENT": "En cours de soumission & gestion",
        "EVENT_IN_PROGRESS": "Évènement en cours",
        "EVENT_VALIDATING": "Validation dépenses",
        "EVENT_IS_FINISHED": "Évènement terminé",
        "IS_DECLARED": "Déclaré",
        "IS_ARCHIVED": "Archivé",
        "IS_PUBLISHED": "Publié",
        "CANCELED": "Annulé"
      },
      "legends": {
        "main": "Notification",
        "identifications": "Identification",
        "criteria": "Critères",
        "recipients": "Destinataires",
        "recipients_message": "(Sélectionnez au moins 1 destinataire)",
        "details": "Détails"
      },
      "submission_regime": {
        "label": "Régime",
        "DECLARATION": "Déclaration",
        "AUTHORIZATION": "Autorisation - Mixte",
        "ALL": "Tous"
      },
      "period": {
        "label": "Période",
        "BEFORE": "Avant",
        "AFTER": "Après"
      },
      "delay": {
        "label": "Délai en jours",
        "5": "5",
        "10": "10",
        "20": "20",
        "30": "30"
      },
      "date_boundary": {
        "label": "Par rapport à",
        "START_AT": "Date de début de l'événement",
        "END_AT": "Date de fin de l'événement"
      },
      "day_type": {
        "label": "Type de jours",
        "WORKING": "Jours ouvrés",
        "BUSINESS": "Jours ouvrables",
        "CALENDAR": "Jours calendaires"
      },
      "types": {
        "DELAY_ALERT": "Alerte sur échéance",
        "CHANGING_STATE": "Changement d'état"
      },
      "internal_emails": "Destinataire(s) manifestation(s)",
      "external_emails": {
        "label": "Destinataire(s) externe(s)",
        "placeholder": "Renseigner une ou plusieurs adresses mails, séparés par une “,”"
      },
      "ticket_roles_to_notify": "Utilisateur(s) rattaché(s) au ticket par rôle",
      "email_object": {
        "label": "Objet de l'email",
        "placeholder": "Renseigner l'objet de l'email"
      },
      "email_body": {
        "label": "Corps de l'email",
        "placeholder": "Renseigner le corps de l'email"
      },
      "comment": {
        "label": "Commentaire",
        "placeholder": "Renseigner un commentaire"
      }
    },
    "create": "Créer",
    "update": "Éditer",
    "cancel": "Annuler",
    "table": {
      "title": "Notifications",
      "cta": "Créer un notification",
      "select": {
        "placeholder": "notification",
        "enabled": "Actif",
        "to_enable": "Activer",
        "disabled": "Inactif",
        "to_disable": "Désactiver"
      }
    },
    "meta": {
      "notification": "Paramétrage des notifications",
      "create": "Création d'une notification",
      "update": "Mise à jour de la notification"
    },
    "email_body": {
      "default": "Bonjour,\n\nLa manifestation {'{'}ticket_code{'}'} est passée à l'état \"{'{'}target_state{'}'}\".\nVous pouvez dès à présent vous connecter pour traiter la manifestation.\n\n{'{'}ticket_link{'}'}.",
      "changing_state": {
        "canceled": "Bonjour,\n\nLa manifestation {'{'}ticket_code{'}'} est passée à l'état \"{'{'}step{'}'}\".\n\n{'{'}ticket_link{'}'}."
      },
      "delay_alert": {
        "day_type": {
          "WORKING": "ouvrés",
          "BUSINESS": "ouvrables",
          "CALENDAR": "calendaires"
        },
        "start_at": {
          "authorization": "Bonjour,\n\nLa manifestation {'{'}ticket_code{'}'} débutera dans {delay_by_days} jours {type_of_days}.\n\nVous pouvez dès à présent vous connecter pour traiter la manifestation.\n\n{'{'}ticket_link{'}'}\n\nCordialement,",
          "declaration": "Bonjour,\n\nLa manifestation {'{'}ticket_code{'}'} débutera dans {delay_by_days} jours {type_of_days}.\n\nVous pouvez dès à présent vous connecter pour traiter la manifestation.\n\n{'{'}ticket_link{'}'}\n\nCordialement,",
          "all": "Bonjour,\n\nLa manifestation {'{'}ticket_code{'}'} débutera dans {delay_by_days} jours {type_of_days}.\n\nVous pouvez dès à présent vous connecter pour traiter la manifestation.\n\n{'{'}ticket_link{'}'}\n\nCordialement,"
        },
        "end_at": {
          "authorization": "Bonjour,\n\nLa manifestation {'{'}ticket_code{'}'} est terminée depuis {delay_by_days} jours {type_of_days}.\n\nCordialement,",
          "declaration": "Bonjour,\n\nLa manifestation {'{'}ticket_code{'}'} est terminée depuis {delay_by_days} jours {type_of_days}.\n\nCordialement,",
          "all": "Bonjour,\n\nLa manifestation {'{'}ticket_code{'}'} est terminée depuis {delay_by_days} jours {type_of_days}.\n\nCordialement,"
        }
      }
    }
  },
  "event_state_badge": {
    "creating": "En création",
    "to_edit": "À modifier",
    "is_canceled": "Annulé",
    "is_archived": "Archivé",
    "is_published": "Publié",
    "is_declared": "Déclaré",
    "first_validation": "Première validation",
    "second_validation": "Deuxième validation",
    "contract_management": "En cours de soumission & gestion",
    "event_in_progress": "Évènement en cours",
    "event_validating": "Validation dépenses",
    "event_is_finished": "Évènement terminé"
  }
}
